var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1215"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1215"
    },
    "bundlingPackage": "feedback-web-renderer-ui",
    "bundlingPackageVersion": "static-1.30474",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};